import { HeaderPanel } from '../../HeaderPanel';
import { headerPanelOptions } from './panelSettings';
import './CustomPreviewPanel.less';
import { HtmlRenderer } from 'components/HtmlRenderer/HtmlRenderer';

interface PropertiesPanelProps {
  preview?: string;
}

export function CustomPreviewPanel({ preview }: PropertiesPanelProps) {
  return (
    <HeaderPanel {...headerPanelOptions('secondary', 'Properties')}>
      <HtmlRenderer className={'dpc-custompreview-panel'} html={preview ? preview : ''} />
    </HeaderPanel>
  );
}
